// extracted by mini-css-extract-plugin
module.exports = {"NavigationContainer":"s_4","Navigation":"s_5","NavigationLink":"s_6","NavigationMobile":"s_7","LogoMobile":"s_8","NavigationLinkMobile":"s_9"};